(function() {
    'use strict';

    class ProtocolProviderService {
        constructor() {
            'ngInject';
            
            this.openedPanes = [];
        }
        setPanes(panes) {
            this.openedPanes = panes;
        }
        getPanes() {
            return this.openedPanes;
        }
    }

    angular
        .module('app.controllers.protocolProvider', [])
        .config(['$stateProvider', function($stateProvider) {
            $stateProvider
                .state('protocolprovider', {
                    abstract: true,
                    parent: 'site',
                    url: '/protocolProvider',
                    template: '<ui-view></ui-view>',
                    breadcrumb: {
                        ignore: true
                    }
                });
        }])
        .config(['$stateProvider', function($stateProvider) {
            $stateProvider
                .state('protocolprovider.view', {
                    url: '/view',
                    parent: 'protocolprovider',
                    templateUrl: 'views/CustomActions/protocolProvider.view.html',
                    controller: 'ProtocolProviderViewCtrl',
                    controllerAs: 'vm',
                    breadcrumb: {
                        name: 'NAV_ProtocolProvider'
                    }
                });
        }])
        .config(['$stateProvider', function($stateProvider) {
            $stateProvider
                .state('protocolprovider.edit', {
                    url: '/edit',
                    parent: 'protocolprovider',
                    templateUrl: 'views/CustomActions/protocolProvider.edit.html',
                    controller: 'ProtocolProviderEditCtrl',
                    controllerAs: 'vm',
                    breadcrumb: {
                        name: 'NAV_ProtocolProviderAdd'
                    }
                });
        }])
        .config(['$stateProvider', function($stateProvider) {
            $stateProvider
                .state('protocolprovider.add', {
                    url: '/add',
                    parent: 'protocolprovider',
                    templateUrl: 'views/CustomActions/protocolProvider.add.html',
                    controller: 'ProtocolProviderAddCtrl',
                    controllerAs: 'vm',
                    breadcrumb: {
                        name: 'NAV_ProtocolProviderEdit'
                    }
                });
        }])
        .controller('ProtocolProviderViewCtrl', ProtocolProviderViewCtrl)
        .controller('ProtocolProviderEditCtrl', ProtocolProviderEditCtrl)
        .controller('ProtocolProviderAddCtrl', ProtocolProviderAddCtrl)
        .service('ProtocolProviderService', ProtocolProviderService);









    /* @ngInject */
    function ProtocolProviderViewCtrl(
        $state,
        __MenuEntry,
        $translate,
        viewMenuBarService,

        API,
        $q,
        ProtocolProviderService
    ) {
        var vm = this;

        viewMenuBarService.setButtons({
            'homeButton': true,
            'backButton': true,
            'editButton': function() {
                let openedPanes = [];
                vm.allProtocols.forEach(function(protocol) {
                    if (protocol.$UI && protocol.$UI.subMenu) {
                        openedPanes.push(protocol.$UI.subMenu);
                    } else {
                        openedPanes.push(false);
                    }
                });
                ProtocolProviderService.setPanes(openedPanes);
                $state.go('protocolprovider.edit');
            },
            'addButton': function() {
                $state.go('protocolprovider.add');
            }
        });

        var favoriteObject = {
            favoriteType: 'MenuEntry',
            favoriteObject: __MenuEntry.$buildRaw({
                "MenuEntryId": 'e0f72f0c-5fc7-4e69-8d2b-b3d0c06c7dfd',
                "MenuEntryType": 3, // For Toggle Favorite to check MenuEntryType.
                "DeviceId": '00000000-0000-0000-0000-000000000000',
                'CustomActionName': 'ProtocolManagement',
                'DisplayName': $translate.instant('NAV_ProtocolProvider'),
                'ImageName': 'system-settings',
                'CustomActionDatas': {},
                $UI: {}
            })
        };
        viewMenuBarService.setFavorite(favoriteObject);

        this.$onInit = function() {

            const protocolsEnumParams = {
                "FilterConfigurations": [{
                    "EnumName": "BMSProtocol",
                    FilterProfile: 1
                }, ]
            };
            const api = new API();
            const protocolsEnumPromise = api.System.ResolveEnums(protocolsEnumParams).$promise;

            $q.all([protocolsEnumPromise, api.System.GetProtocolProviderSettings({
                    Protocol: -1,
                    IncludeDisabled: true,
                }).$promise])
                .then((promiseData) => {
                    const allProtocolNames = promiseData[0][0].Metadata;
                    let allProtocols = promiseData[1];
                    allProtocols.forEach((prot) => {
                        if (prot.Disabled === undefined) {
                            prot.Disabled = false;
                        }
                        prot._GeneratedId = generateGuid();
                    });

                    allProtocols.forEach(function(protocol) {
                        const protocolInfo = allProtocolNames[protocol.Protocol];
                        if (protocolInfo === undefined) {
                            protocol._DisplayName = '?';
                        }
                        else {
                            protocol._DisplayName = protocolInfo.DisplayName;
                        }

                        if (!protocol.$UI && (protocol.Parameters || protocol.PortAddress || protocol.Error)) {
                            protocol.$UI = {
                                subMenu: false,
                                shouldBeUpdated: false,
                                shouldBeDeleted: false,
                            };
                        }
                    });
                    vm.allProtocols = allProtocols;

                });

        };

        vm.openCloseProtocol = function(protocol) {
            protocol.$UI.subMenu = !protocol.$UI.subMenu;
        };

        const generateGuid = () => {
            let S4 = function() {
               return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
            };
            return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
        }
    }









    /* @ngInject */
    function ProtocolProviderEditCtrl(
        $state,
        __MenuEntry,
        $translate,
        viewMenuBarService,

        API,
        $q,
        ProtocolProviderService
    ) {
        var vm = this;

        viewMenuBarService.setButtons({
            'homeButton': false,
            'backButton': false,
            'revertButton': function() {
                $state.go('protocolprovider.view');
            },
            'saveButton': function() {
                saveProtocolsChanges();
            }
        });

        var favoriteObject = {
            favoriteType: 'MenuEntry',
            favoriteObject: __MenuEntry.$buildRaw({
                "MenuEntryId": 'e0f72f0c-5fc7-4e69-8d2b-b3d0c06c7dfd',
                "MenuEntryType": 3, // For Toggle Favorite to check MenuEntryType.
                "DeviceId": '00000000-0000-0000-0000-000000000000',
                'CustomActionName': 'ProtocolManagement',
                'DisplayName': $translate.instant('NAV_ProtocolProvider'),
                'ImageName': 'system-settings',
                'CustomActionDatas': {},
                $UI: {}
            })
        };
        viewMenuBarService.setFavorite(favoriteObject);

        this.$onInit = function() {

            const protocolsEnumParams = {
                "FilterConfigurations": [{
                    "EnumName": "BMSProtocol",
                    FilterProfile: 1
                }, ]
            };
            const api = new API();
            const protocolsEnumPromise = api.System.ResolveEnums(protocolsEnumParams).$promise;

            $q.all([protocolsEnumPromise, api.System.GetProtocolProviderSettings({
                    Protocol: -1,
                    IncludeDisabled: true,
                }).$promise])
                .then((promiseData) => {
                    const allProtocolNames = promiseData[0][0].Metadata;
                    let allProtocols = promiseData[1];
                    allProtocols.forEach((prot) => {
                        if (prot.Disabled === undefined) {
                            prot.Disabled = false;
                        }
                        prot._GeneratedId = generateGuid();
                    });

                    for (var i = 0; i < allProtocols.length; i++) {
                        const protocol = allProtocols[i];

                        const protocolInfo = allProtocolNames[protocol.Protocol];
                        if (protocolInfo === undefined) {
                            protocol._DisplayName = '?';
                        }
                        else {
                            protocol._DisplayName = protocolInfo.DisplayName;
                        }
                        
                        if (!protocol.$UI) {
                            protocol.$UI = {};
                        }
                        if (protocol.Parameters || protocol.PortAddress) {
                            protocol.$UI = {
                                subMenu: ProtocolProviderService.getPanes()[i],
                                shouldBeUpdated: false,
                                shouldBeDeleted: false,
                            };
                        }
                    }
                    vm.allProtocols = allProtocols;
                });

        };

        vm.openCloseProtocol = function(protocol) {
            protocol.$UI.subMenu = !protocol.$UI.subMenu;
        };

        function saveProtocolsChanges() {
            deleteProtocols()
            .then(() => {
                let protocolsToSave = [];
                if (vm.allProtocols) {

                    const protocolsToUpdate = vm.allProtocols.filter((prot) => prot.$UI.shouldBeUpdated === true && prot.$UI.shouldBeDeleted === false);
                    protocolsToUpdate.filter((prot) => prot.Disabled === true).forEach((prot) => prepareProtocolToSave(prot, protocolsToSave));
                    protocolsToUpdate.filter((prot) => prot.Disabled === false).forEach((prot) => prepareProtocolToSave(prot, protocolsToSave));

                    function prepareProtocolToSave(protocol, protocolsToSave) {
                        const protocolsEnumParams = {
                            ProtocolSetting: {
                                'Disabled': protocol.Disabled,
                                'Protocol': protocol.Protocol,
                                'PortAddress': protocol.PortAddress,
                                'Parameters': protocol.Parameters
                            }
                        };
                        if (protocol.Id) {
                            protocolsEnumParams.ProtocolSetting.Id = protocol.Id;
                        }

                        const api = new API();
                        protocolsToSave.push(api.System.AddOrUpdateProtocolProviderSetting(protocolsEnumParams).$promise);
                    }

                    $q.all(protocolsToSave)
                        .then(() => $state.go('protocolprovider.view'))
                        .catch(() => {
                            $state.go('protocolprovider.edit', {}, {
                                reload: true,
                            })
                        });
                }
            });
        }

        function deleteProtocols() {
            const defer = $q.defer();

            const protocolsToDelete = vm.allProtocols.filter((prot) => prot.$UI.shouldBeDeleted === true);
            if (protocolsToDelete.length > 0) {
                let promisses = [];
                protocolsToDelete.forEach(function(protocol) {
                    let protocolsEnumParams;
                    const api = new API();
                    if (protocol.Id) {
                        protocolsEnumParams = {
                            Id: protocol.Id,
                        };
                        promisses.push(api.System.RemoveProtocolProviderSettingById(protocolsEnumParams).$promise);
                    } else {
                        /* Fallback for older versions. */
                        protocolsEnumParams = {
                            Protocol: protocol.Protocol,
                            Port: protocol.PortAddress
                        };
                        promisses.push(api.System.RemoveProtocolProviderSetting(protocolsEnumParams).$promise);
                    }
                });
                $q.all(promisses).then(() => defer.resolve());
            } else {
                defer.resolve();
            }

            return defer.promise;
        }

        vm.deleteProtocolFromList = function(protocol) {
            protocol.$UI.shouldBeDeleted = true;
        };

        vm.toggleActiveProtocolState = function(actualProtocol) {
            actualProtocol.Disabled = !actualProtocol.Disabled;
            actualProtocol.$UI.shouldBeUpdated = true;
        };

        vm.inputChanged = function(actualProtocol) {
            actualProtocol.$UI.shouldBeUpdated = true;
        }

        const generateGuid = () => {
            let S4 = function() {
               return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
            };
            return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
        }
    }









    /* @ngInject */
    function ProtocolProviderAddCtrl(
        $state,
        __MenuEntry,
        $translate,
        viewMenuBarService,

        API,
        protocolPickerModal
    ) {
        var vm = this;
        vm.newProtocol = {};

        viewMenuBarService.setButtons({
            'homeButton': false,
            'backButton': false,
            'revertButton': function() {
                $state.go('protocolprovider.view');
            },
            'saveButton': function() {
                saveNewProtocol();
            }
        });

        var favoriteObject = {
            favoriteType: 'MenuEntry',
            favoriteObject: __MenuEntry.$buildRaw({
                "MenuEntryId": 'e0f72f0c-5fc7-4e69-8d2b-b3d0c06c7dfd',
                "MenuEntryType": 3, // For Toggle Favorite to check MenuEntryType.
                "DeviceId": '00000000-0000-0000-0000-000000000000',
                'CustomActionName': 'ProtocolManagement',
                'DisplayName': $translate.instant('NAV_ProtocolProvider'),
                'ImageName': 'system-settings',
                'CustomActionDatas': {},
                $UI: {}
            })
        };
        viewMenuBarService.setFavorite(favoriteObject);

        function saveNewProtocol() {
            delete vm.newProtocol._DisplayName;
            delete vm.newProtocol._GeneratedId;

            let protocolsEnumParams = {
                ProtocolSetting: {
                    'Protocol': vm.newProtocol.Protocol,
                    'PortAddress': vm.newProtocol.PortAddress,
                    'Parameters': vm.newProtocol.Parameters
                }
            };

            const api = new API();
            api.System.AddOrUpdateProtocolProviderSetting(protocolsEnumParams).$promise
                .then(function() {
                    $state.go('protocolprovider.view');
                });
        }

        vm.setProtocol = function() {
            protocolPickerModal().then(function(modal) {
                modal.close.then(function(result) {
                    if (result) {
                        vm.newProtocol.Protocol = result.$pk;
                        vm.newProtocol._DisplayName = result.DisplayName;
                        vm.newProtocol.Parameters = prepareDefaultProtocolParams(result.$pk);
                    }
                });
            });

            function prepareDefaultProtocolParams(selectedProtocolEnumNumber) {
                if (selectedProtocolEnumNumber === 2) {
                    return {
                        Baudrate: '38400',
                        DataBits: '8',
                        Parity: 'None',
                        StopBits: 'One',
                        RetryCount: '5'
                    };
                } else if (selectedProtocolEnumNumber === 12) {
                    return {
                        Baudrate: '9600',
                        DataBits: '8',
                        Parity: 'None',
                        StopBits: 'One',
                        CacheTime: '60'
                    };
                } else {
                    return {};
                }
            }
        };
    }

})();
